export const requestNotificationPermission = (
  callback: () => void,
  setNotificationPermission: (
    value: React.SetStateAction<NotificationPermission | undefined>
  ) => void
) => {
  if (!("Notification" in window)) {
    alert("This browser does not support notifications.");
    callback();
  } else if (Notification.permission === "granted") {
    alert("You have already granted permission for notifications.");
    callback();
  } else if (Notification.permission !== "denied") {
    Notification.requestPermission().then((permission) => {
      setNotificationPermission(permission);
      callback();
    });
  } else {
    alert(
      "You have denied permission for notifications. Please enable it in your browser settings."
    );
    callback();
  }
};

export const sendNotification = (title: string, options: any) => {
  if (Notification.permission === "granted") {
    const notification = new Notification(title, options);
    notification.onclick = () => {
      window.focus();
      notification.close();
    };
  } else {
    console.log("Permission to send notifications is not granted");
  }
};

export const debounce = <T extends (...args: any[]) => void>(
  func: T,
  wait: number
) => {
  let timeout: NodeJS.Timeout;
  return (...args: Parameters<T>) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
};
